import ApiService from '@/services/api.service'

const ePharmacyItemsLocationService = {

    getAll(parameter){       
        const requestData = {
            method: 'get',
            url: "/PharmacyLocations/",       
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,  
            }
          }
          return ApiService.customRequest(requestData);
    },
    Add(data){
        return ApiService.post(`/PharmacyLocations`, data);
    },
    Delete(Id){      
        return ApiService.delete(`/PharmacyLocations/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/PharmacyLocations/${Id}`,data);
    },   
    Get(Id){     
        return ApiService.get(`/PharmacyLocations/${Id}`);
    },
    getAllForRelocation(){       
        return ApiService.get(`/PharmacyLocations/Relocation`);
    },
}

export default ePharmacyItemsLocationService;